import update from 'immutability-helper';
import {
  FETCH_POIS_SUCCESS,
  FETCH_POIS_FAIL,
  FETCH_POI_DETAIL_SUCCESS,
  FETCH_POI_DETAIL_FAIL,
  FETCH_POI_DETAIL_FROM_POI_BANK_SUCCESS,
  FETCH_POI_DETAIL_FROM_POI_BANK_FAIL,
  FETCH_POI_ROUTE_SUCCESS,
  FETCH_POI_ROUTE_FAIL,
  FETCH_TEXT_NOTE_FAIL,
  FETCH_TEXT_NOTE_SUCCESS,
  UPDATE_START_TIME_SUCCESS,
  UPDATE_START_TIME_FAIL,
  UPDATE_STAY_TIME_SUCCESS,
  UPDATE_STAY_TIME_FAIL,
  POST_ROUTE_SUCCESS,
  POST_ROUTE_FAIL,
  UPDATE_TRIP_INFO_SUCCESS,
  UPDATE_TRIP_INFO_FAIL,
  COPY_POI_SUCCESS,
  COPY_POI_FAIL,
  REMOVE_POIS_SUCCESS,
  REMOVE_POIS_FAIL,
  POST_TEXT_NOTE_SUCCESS,
  POST_TEXT_NOTE_FAIL,
  EDIT_ALIAS_NAME_SUCCESS,
  EDIT_ALIAS_NAME,
  CUSTOMIZE_TRANSPORTATION_TIME_SUCCESS,
  CUSTOMIZE_TRANSPORTATION_TIME_FAIL,
  ONE_MORE_DAY_SUCCESS,
  ONE_MORE_DAY_FAIL,
  REMOVE_DAYS_SUCCESS,
  REMOVE_DAYS_FAIL,
  ADD_POI_SUCCESS,
  ADD_POI_FAIL,
  UPDATE_PERMISSION_OF_TRIP_SUCCESS,
  UPDATE_PERMISSION_OF_TRIP_FAIL,
  SYNC_REMOVE_TRAVEL_COMPANIONS_SUCCESS,
  SYNC_REMOVE_TRAVEL_COMPANIONS_FAIL,
  REINDEX_POI_SEQUENCE_SUCCESS,
  REINDEX_POI_SEQUENCE_FAIL,
  REINDEX_DAY_SEQUENCE_SUCCESS,
  REINDEX_DAY_SEQUENCE_FAIL,
  REARRANGE_POI_SEQUENCE_SUCCESS,
  REARRANGE_POI_SEQUENCE_FAIL,
  CHANGE_TRANSPORTATION_TYPE_SUCCESS,
  CHANGE_ROUTING_PREFERENCES,
  TRIGGER_DIRECTION_MANAGER,
  SHOW_ADD_POI,
  SET_TRANSPORTATION_AIRPLANE_TYPE,
  SET_AIRPLANE_APPROXIMATE_TRANSPORTATION_TIME_FLAG,
  FETCH_TRIPS_COMMENTS_LOADING,
  FETCH_TRIPS_COMMENTS_SUCCESS,
  FETCH_TRIPS_COMMENTS_FAIL,
  SET_NEXT_TRIPS_COMMENTS,
  SET_NEXT_TRIPS_REPLY,
  SET_TRIPS_COMMENTS,
  SET_TRIPS_REPLYS,
  DELETE_TRIPS_COMMENTS,
  DELETE_TRIPS_REPLYS,
  RESET_ITINERARY,
  SET_NORTHEAST_AND_SOUTHEAST,
  POST_TRIP_PUBLIC_STATUS_SUCCESS,
  MORE_DAYS_SUCCESS
} from '../actions/action_types';
import { POI_DETAIL_TYPE_FOR_ITINERARY } from './view_state';
import {
  POI_BANK_NEXT_URL_TYPE_FACEBOOK,
  POI_BANK_NEXT_URL_TYPE_WEB_SITE,
  POI_BANK_NEXT_URL_TYPE_TWITTER,
  POI_BANK_NEXT_URL_TYPE_WIKI
} from '../utilities/constants';
import {
  generateFormattedPois,
  calculateTimeForFormattedPoisByDays
} from '../utilities/format_pois_util';

const initState = {
  data: null,
  error: null,
  newDaySequence: 1,
  newPoiSequenceIndex: 10,
  previousPoiSequenceIndex: 10,
  nexPoiSequenceIndex: 10,
  commemts: {
    isCommemtsLoading: false,
    data: [],
    dataNext: false
  },
  map: {
    northEast: null,
    southEast: null
  }
};

const copyState = JSON.parse(JSON.stringify(initState));

export default (state = copyState, action) => {
  // console.log('itinerary reducer state = ', action.type);
  switch (action.type) {
    case FETCH_POIS_SUCCESS:
      // // console.log('FETCH_POIS_SUCCESS = ', action.payload.results);
      return handleFetchPoisSuccess(state, action.payload.results);
    case FETCH_POIS_FAIL:
      return { data: null, error: action.payload };
    case FETCH_POI_DETAIL_SUCCESS:
      return handleFetchPoiDetailSuccess(
        state,
        action.payload.poiObjectId,
        action.payload.results,
        action.payload.type
      );
    case FETCH_POI_DETAIL_FAIL:
      // set poi detail of poi to null
      return handleFetchPoiDetailFail(
        state,
        action.payload.poiObjectId,
        action.payload.results,
        action.payload.type
      );
    case FETCH_POI_DETAIL_FROM_POI_BANK_SUCCESS:
      // console.log(
      //   ' handleFetchPoiDetailFromPoiBankSuccess payload = ',
      //   action.payload
      // );
      return handleFetchPoiDetailFromPoiBankSuccess(
        state,
        action.payload.poiObjectId,
        action.payload.type,
        action.payload.results
      );
    case FETCH_POI_DETAIL_FROM_POI_BANK_FAIL:
      // set poi detail of poi to null
      return handleFetchPoiDetailFromPoiBankFail(
        state,
        action.payload.poiObjectId,
        action.payload.type,
        action.payload.results
      );
    case FETCH_TEXT_NOTE_SUCCESS:
      return handleFetchTextNoteSuccess(
        state,
        action.payload.poiObjectId,
        action.payload.results
      );
    case FETCH_TEXT_NOTE_FAIL:
      // set text note of poi to null
      return handleFetchTextNoteFail(
        state,
        action.payload.poiObjectId,
        action.payload.results
      );
    case FETCH_POI_ROUTE_SUCCESS:
      return handleFetchPoiRouteSuccess(
        state,
        action.payload.poiObjectId,
        action.payload.results
      );
    case FETCH_POI_ROUTE_FAIL:
      return handleFetchPoiRouteFail(
        state,
        action.payload.poiObjectId,
        action.payload.results
      );
    case UPDATE_START_TIME_SUCCESS:
      // update start time
      return handleEditStartTimeSuccess(state, action.payload.results);
    case UPDATE_START_TIME_FAIL:
      return { ...state };
    case UPDATE_STAY_TIME_SUCCESS:
      // update stay time
      return handleUpdateStayTimeSuccess(state, action.payload.results);
    case UPDATE_STAY_TIME_FAIL:
      return { ...state };
    case POST_ROUTE_SUCCESS:
      // post route
      return handlePostRouteSuccess(state, action.payload.results);
    case POST_ROUTE_FAIL:
      // todo
      break;
    case UPDATE_TRIP_INFO_SUCCESS:
      // update trip info
      return handleUpdateTripInfoSuccess(state, action.payload.results);
    case UPDATE_TRIP_INFO_FAIL:
      return { ...state };
    case COPY_POI_SUCCESS:
      // copy poi
      return handleCopyPoiSuccess(state, action.payload.results);
    case COPY_POI_FAIL:
      // todo
      break;
    case REMOVE_POIS_SUCCESS:
      // remove pois
      return handleRemovePoisSuccess(state, action.payload.results);
    case REMOVE_POIS_FAIL:
      // todo
      break;
    case POST_TEXT_NOTE_SUCCESS:
      // post text note
      return handlePostTextNoteSuccess(state, action.payload.results);
    case POST_TEXT_NOTE_FAIL:
      // todo
      break;
    case EDIT_ALIAS_NAME_SUCCESS:
      // edit ailas name
      return handleEditAliasSuccess(state, action.payload.results);
    case EDIT_ALIAS_NAME:
      // todo
      break;
    case CUSTOMIZE_TRANSPORTATION_TIME_SUCCESS:
      // customize transportation time
      return handleCustomizeTransportationTimeSuccess(
        state,
        action.payload.results
      );
    case CUSTOMIZE_TRANSPORTATION_TIME_FAIL:
      // todo
      break;
    case ONE_MORE_DAY_SUCCESS:
      // one more day
      return handleOneMoreDaySuccess(state, action.payload.results);
    case ONE_MORE_DAY_FAIL:
      // todo
      break;
    case REMOVE_DAYS_SUCCESS:
      // remove days
      return handleRemoveDaysSuccess(state, action.payload.results);
    case REMOVE_DAYS_FAIL:
      // todo
      break;
    case ADD_POI_SUCCESS:
      // add poi
      return handleAddPoiSuccess(state, action.payload.results);
    case ADD_POI_FAIL:
      // todo
      break;
    case UPDATE_PERMISSION_OF_TRIP_SUCCESS:
      // update permission of trip
      return handleUpdatePermissionOfTripSuccess(state, action.payload.results);
    case UPDATE_PERMISSION_OF_TRIP_FAIL:
      // todo
      break;
    case SYNC_REMOVE_TRAVEL_COMPANIONS_SUCCESS:
      // remove travel companions
      return handleRemoveTravelCompanionsSuccess(state, action.payload.results);
    case SYNC_REMOVE_TRAVEL_COMPANIONS_FAIL:
      // todo
      break;
    case REINDEX_POI_SEQUENCE_SUCCESS:
      // remove travel companions
      return handleReindexPoiSequenceSuccess(state, action.payload.results);
    case REINDEX_POI_SEQUENCE_FAIL:
      // todo
      break;
    case REINDEX_DAY_SEQUENCE_SUCCESS:
      // reindex day sequence
      return handleReindexDaySequenceSuccess(state, action.payload.results);
    case REINDEX_DAY_SEQUENCE_FAIL:
      // todo
      break;
    case REARRANGE_POI_SEQUENCE_SUCCESS:
      // rearrange poi sequence
      return handleRearrangePoiSequenceSuccess(state, action.payload.results);
    case REARRANGE_POI_SEQUENCE_FAIL:
      // todo
      break;
    case CHANGE_TRANSPORTATION_TYPE_SUCCESS:
      return handleChangeTransportationTypeSuccess(state, action.payload);
    case CHANGE_ROUTING_PREFERENCES:
      return handleChangeRoutingPreferences(state, action.payload);
    case TRIGGER_DIRECTION_MANAGER:
      return handleTriggerDirectionManager(state);
    case SET_TRANSPORTATION_AIRPLANE_TYPE:
      return handleChangeTransportationAirplaneType(state, action.payload);
    case SET_AIRPLANE_APPROXIMATE_TRANSPORTATION_TIME_FLAG:
      return addAirplaneApproximateTransportationTimeFlag(
        state,
        action.payload
      );
    case SHOW_ADD_POI:
      return {
        ...state,
        newDaySequence: action.payload.daySequence,
        newPoiSequenceIndex: action.payload.poiSequenceIndex,
        previousPoiSequenceIndex: action.payload.previousPoiSequenceIndex,
        nexPoiSequenceIndex: action.payload.nexPoiSequenceIndex
      };
    case FETCH_TRIPS_COMMENTS_LOADING:
      return {
        ...state,
        commemts: {
          ...state.commemts,
          isCommemtsLoading: true
        }
      };
    case FETCH_TRIPS_COMMENTS_SUCCESS:
      return {
        ...state,
        commemts: {
          ...state.commemts,
          isCommemtsLoading: false,
          data: action.payload.data,
          dataNext: action.payload.dataNext
        }
      };
    case FETCH_TRIPS_COMMENTS_FAIL:
      return {
        ...state,
        commemts: {
          ...state.commemts,
          isCommemtsLoading: false
        }
      };
    case SET_NEXT_TRIPS_COMMENTS:
      return {
        ...state,
        commemts: {
          ...state.commemts,
          data: state.commemts.data.concat(action.payload.data),
          dataNext: action.payload.dataNext
        }
      };
    case SET_NEXT_TRIPS_REPLY:
      return handelConcatNextReply(state, action.payload);
    case SET_TRIPS_COMMENTS:
      return handleCommentsOfTrips(state, action.payload);
    case SET_TRIPS_REPLYS:
      return handlReplysOfComments(state, action.payload);
    case DELETE_TRIPS_COMMENTS:
      return handlDeleteCommentsOfTrips(state, action.payload);
    case DELETE_TRIPS_REPLYS:
      return handlDeleteReplysOfComments(state, action.payload);
    case SET_NORTHEAST_AND_SOUTHEAST:
      return {
        ...state,
        map: {
          ...state.map,
          northEast: action.payload.northEast,
          southEast: action.payload.southEast
        }
      };
    case RESET_ITINERARY:
      return initState;
    case POST_TRIP_PUBLIC_STATUS_SUCCESS: {
      if (!state.data) {
        return { ...state };
      }

      return {
        ...state,
        data: {
          ...state.data,
          publicStatus: action.payload.status
        }
      };
    }
    case MORE_DAYS_SUCCESS: {
      const { originDaysCount, dayCount, revision, start } = action.payload;
      const { formattedPois } = state.data;
      const newDayObject = {};
      for (let index = originDaysCount + 1; index <= dayCount; index++) {
        const key = getKey(index);
        newDayObject[index] = { id: key, dayArray: [] };
      }
      const newState = update(state, {
        data: {
          dayCount: {
            $set: dayCount
          },
          startDate: {
            $set: start
          },
          formattedPois: {
            $set: { ...formattedPois, ...newDayObject }
          },
          revision: {
            $set: revision
          }
        }
      });
      return newState;
    }
    default:
      return state;
  }
  return state;
};

// fetch poi
const handleFetchPoisSuccess = (state, results) => {
  const itinerary = results;
  itinerary.pois = itinerary.pois.sort(sortingByPoiSequence);
  itinerary.formattedPois = generateFormattedPois(itinerary);
  itinerary.dispatchRouteRevision = 1;
  itinerary.revision = results.revision;
  delete itinerary.pois;
  return { ...state, data: itinerary, error: null };
};

// fetch poi detail
const handleFetchPoiDetailSuccess = (state, poiObjectId, results, type) => {
  if (type === POI_DETAIL_TYPE_FOR_ITINERARY) {
    const itinerary = state.data;
    const { poi, index } = findPoiById(itinerary, poiObjectId);

    if (index === null || !poi) {
      return state;
    }

    const day = poi.daySequence.toString();
    const newState = update(state, {
      data: {
        formattedPois: {
          [day]: { dayArray: { [index]: { poiDetail: { $set: results } } } }
        },
        // for regenerate sotrableItemArray(due to post route will not update revision of
        // itinerary, use sortableItemArrayRevision to update sotrableItemArray)
        // should regenerate sortableItemArray if poi has been updated
        // (for revision has not been updated)
        sortableItemArrayRevision: {
          $set: itinerary.sortableItemArrayRevision
            ? itinerary.sortableItemArrayRevision + 1
            : 1
        }
      }
    });

    return newState;
  }
  // console.log(' itinerary reducer not handle');
  return state;
};

const handleFetchPoiDetailFail = (state, poiObjectId, results, type) => {
  if (type === POI_DETAIL_TYPE_FOR_ITINERARY) {
    const itinerary = state.data;
    const { poi, index } = findPoiById(itinerary, poiObjectId);

    if (index === null || !poi) {
      return state;
    }

    const day = poi.daySequence.toString();
    const newState = update(state, {
      data: {
        formattedPois: {
          [day]: { dayArray: { [index]: { poiDetail: { $set: null } } } }
        }
      }
    });

    return newState;
  }
  return state;
};

// fetch poi detail from poi bank
const handleFetchPoiDetailFromPoiBankSuccess = (
  state,
  poiObjectId,
  type,
  results
) => {
  // console.log(' handleFetchPoiDetailFromPoiBankSuccess type  = ', type);
  if (type !== POI_DETAIL_TYPE_FOR_ITINERARY) {
    return state;
  }

  const itinerary = state.data;
  const poiDetail = { ...results };
  const { urls } = poiDetail;
  const { poi, index } = findPoiById(itinerary, poiObjectId);

  if (index === null || !poi) {
    return state;
  }

  // urls
  if (urls) {
    for (let i = 0; i < results.urls.length; i++) {
      const url = results.urls[i];
      if (url.type === POI_BANK_NEXT_URL_TYPE_WEB_SITE) {
        poiDetail.website = url.url;
      } else if (url.type === POI_BANK_NEXT_URL_TYPE_FACEBOOK) {
        poiDetail.facebook = results.url;
      } else if (url.type === POI_BANK_NEXT_URL_TYPE_WIKI) {
        poiDetail.wiki = url.url;
      } else if (url.type === POI_BANK_NEXT_URL_TYPE_TWITTER) {
        poiDetail.twitter = url.url;
      }
    }
    delete poiDetail.urls;
  }
  // console.log(' poi = ', poi);

  // photos
  const day = poi.daySequence.toString();
  const newState = update(state, {
    data: {
      formattedPois: {
        [day]: {
          dayArray: {
            [index]: {
              poiDetail: { $set: poiDetail },
              name: { $set: poiDetail.name },
              address: { $set: poiDetail.address }
            }
          }
        }
      },
      // for regenerate sotrableItemArray(due to post route will not update revision of
      // itinerary, use sortableItemArrayRevision to update sotrableItemArray)
      // should regenerate sortableItemArray if poi has been updated
      // (for revision has not been updated)
      sortableItemArrayRevision: {
        $set: itinerary.sortableItemArrayRevision
          ? itinerary.sortableItemArrayRevision + 1
          : 1
      }
    }
  });

  return newState;
};

const handleFetchPoiDetailFromPoiBankFail = (
  state,
  poiObjectId,
  type,
  results
) => {
  if (type !== POI_DETAIL_TYPE_FOR_ITINERARY) {
    return state;
  }

  const itinerary = state.data;
  const { poi, index } = findPoiById(itinerary, poiObjectId);

  if (index === null || !poi) {
    return state;
  }

  const day = poi.daySequence.toString();
  const newState = update(state, {
    data: {
      formattedPois: {
        [day]: { dayArray: { [index]: { poiDetail: { $set: null } } } }
      }
    }
  });

  return newState;
};

// fetch text note
const handleFetchTextNoteSuccess = (state, poiObjectId, results) => {
  const itinerary = state.data;
  const { poi, index } = findPoiById(itinerary, poiObjectId);
  const { _id, text } = results;

  if (index === null || !poi) {
    return state;
  }

  const day = poi.daySequence.toString();
  const newState = update(state, {
    data: {
      formattedPois: {
        [day]: {
          dayArray: {
            [index]: {
              textNote: {
                _id: { $set: _id },
                text: { $set: text },
                shouldSyncWithServer: { $set: false }
              }
            }
          }
        }
      },
      // for regenerate sotrableItemArray(due to post route will not update revision of
      // itinerary, use sortableItemArrayRevision to update sotrableItemArray)
      // should regenerate sortableItemArray if poi has been updated
      // (for revision has not been updated)
      sortableItemArrayRevision: {
        $set: itinerary.sortableItemArrayRevision
          ? itinerary.sortableItemArrayRevision + 1
          : 1
      }
    }
  });

  return newState;
};

const handleFetchTextNoteFail = (state, poiObjectId, results) => {
  const itinerary = state.data;
  const { poi, index } = findPoiById(itinerary, poiObjectId);

  if (index === null || !poi) {
    return state;
  }

  const day = poi.daySequence.toString();
  const newState = update(state, {
    [day]: { dayArray: { [index]: { textNote: { text: { $set: null } } } } }
  });

  return newState;
};

// fetch route
const handleFetchPoiRouteSuccess = (state, poiObjectId, results) => {
  const itinerary = state.data;
  const { poi, index } = findPoiById(itinerary, poiObjectId);

  if (index === null || !poi) {
    return state;
  }

  // console.log(' handle fetch poi route success results = ', results);
  const day = poi.daySequence.toString();
  const newState = update(state, {
    data: {
      formattedPois: {
        [day]: { dayArray: { [index]: { route: { $set: results } } } }
      },
      // for regenerate sotrableItemArray(due to post route will not update revision of
      // itinerary, use sortableItemArrayRevision to update sotrableItemArray)
      sortableItemArrayRevision: {
        $set: itinerary.sortableItemArrayRevision
          ? itinerary.sortableItemArrayRevision + 1
          : 1
      }
    }
  });

  return newState;
};

const handleFetchPoiRouteFail = (state, poiObjectId, results) => {
  const itinerary = state.data;
  const { poi, index } = findPoiById(itinerary, poiObjectId);

  if (index === null || !poi) {
    return state;
  }

  const day = poi.daySequence.toString();
  const newState = update(state, {
    data: {
      formattedPois: {
        [day]: { dayArray: { [index]: { route: { $set: null } } } }
      }
    }
  });

  return newState;
};

const handleChangeTransportationTypeSuccess = (state, payload) => {
  const { poiObjectId, transportationType, collaboration, results } = payload;
  const itinerary = state.data;
  const { startTime } = itinerary;
  const {
    poi: { daySequence, poiSequenceIndex },
    index
  } = findPoiById(itinerary, poiObjectId);

  if (index === null) {
    return state;
  }

  const updateParameters = {
    transportationType,
    transportationTime: '-1',
    overviewPolyline: '',
    route: {}
  };

  if (results && results.drivingRestriction) {
    updateParameters.drivingRestriction = results.drivingRestriction;
  }

  if (results && results.transitMode) {
    updateParameters.transitMode = results.transitMode;
  }

  // update poi properties
  const newFormattedPois = updatePoiProperty(
    itinerary,
    poiObjectId,
    updateParameters
  );

  // reset transportation time if poi's transportation type is public transit on the given day
  if (collaboration !== true) {
    resetRouteForFormattedPoisByDay(
      [{ daySequence, minPoiSequence: poiSequenceIndex }],
      newFormattedPois
    );
  }

  // recalculate time for pois
  calculateTimeForFormattedPoisByDays(
    [daySequence],
    startTime,
    newFormattedPois
  );
  const newState = update(state, {
    data: {
      dispatchRouteRevision: { $set: itinerary.dispatchRouteRevision + 1 },
      formattedPois: {
        $set: newFormattedPois
      },
      // for regenerate sotrableItemArray(due to post route will not update revision of
      // itinerary, use sortableItemArrayRevision to update sotrableItemArray)
      // should regenerate sortableItemArray if poi has been updated
      // (for revision has not been updated)
      sortableItemArrayRevision: {
        $set: itinerary.sortableItemArrayRevision
          ? itinerary.sortableItemArrayRevision + 1
          : 1
      }
    }
  });

  return newState;
};

const handleTriggerDirectionManager = state => {
  const itinerary = state.data;
  return update(state, {
    data: {
      dispatchRouteRevision: { $set: itinerary.dispatchRouteRevision + 1 }
    }
  });
};

const handleChangeRoutingPreferences = (state, payload) => {
  const { poiObjectId, preferences } = payload;
  const itinerary = state.data;
  const { startTime } = itinerary;
  const {
    poi: { daySequence, poiSequenceIndex },
    index
  } = findPoiById(itinerary, poiObjectId);

  if (index === null) {
    return state;
  }

  // update poi properties
  const newFormattedPois = updatePoiProperty(itinerary, poiObjectId, {
    transportationTime: '-1',
    overviewPolyline: '',
    route: {},
    ...preferences
  });

  // recalculate time for pois
  calculateTimeForFormattedPoisByDays(
    [daySequence],
    startTime,
    newFormattedPois
  );
  const newState = update(state, {
    data: {
      dispatchRouteRevision: { $set: itinerary.dispatchRouteRevision + 1 },
      formattedPois: {
        $set: newFormattedPois
      }
    }
  });

  resetRouteForFormattedPoisByDay(
    [{ daySequence, minPoiSequence: poiSequenceIndex }],
    newFormattedPois
  );

  return newState;
};

// ===== Collaboration =====
// sync data : edit start time
const handleEditStartTimeSuccess = (state, results) => {
  const itinerary = state.data;
  const {
    daySequence,
    startTime: time,
    collaboration,
    resetTransportationTimeArray,
    revision
  } = results;
  const { formattedPois, startTime } = itinerary;
  // update start time
  const newStartTime = { ...startTime, [daySequence]: time };
  const newFormattedPois = { ...formattedPois };

  // using resetTransportationTimeArray to reset transportation time of pois
  if (collaboration !== true) {
    resetRouteForFormattedPoisById(
      resetTransportationTimeArray,
      newFormattedPois
    );
  }

  // recalculate time for pois
  calculateTimeForFormattedPoisByDays(
    [daySequence],
    newStartTime,
    newFormattedPois
  );
  const newState = update(state, {
    data: {
      dispatchRouteRevision: { $set: itinerary.dispatchRouteRevision + 1 },
      startTime: { $set: newStartTime },
      formattedPois: {
        $set: newFormattedPois
      },
      revision: {
        $set: revision
      }
    }
  });

  return newState;
};

// sync data : edit stay time
const handleUpdateStayTimeSuccess = (state, results) => {
  const itinerary = state.data;
  const { startTime } = itinerary;
  const {
    parsePoiObjectId: poiObjectId,
    stayTime: time,
    collaboration,
    resetTransportationTimeArray,
    revision
  } = results;
  // update stay time
  const newFormattedPois = updatePoiProperty(itinerary, poiObjectId, {
    stayTime: time
  });

  const {
    poi: { daySequence }
  } = findPoiById(itinerary, poiObjectId);

  // using resetTransportationTimeArray to reset transportation time of pois
  if (collaboration !== true) {
    resetRouteForFormattedPoisById(
      resetTransportationTimeArray,
      newFormattedPois
    );
  }

  // recalculate time for pois
  calculateTimeForFormattedPoisByDays(
    [daySequence],
    startTime,
    newFormattedPois
  );

  const newState = update(state, {
    data: {
      dispatchRouteRevision: { $set: itinerary.dispatchRouteRevision + 1 },
      formattedPois: {
        $set: newFormattedPois
      },
      revision: {
        $set: revision
      }
    }
  });
  return newState;
};

// sync data : post route
const handlePostRouteSuccess = (state, results) => {
  // console.log(' handle post route success results = ', results);
  const itinerary = state.data;
  const { startTime } = itinerary;
  const {
    _id: routeObjectId,
    parsePoiObjectId: poiObjectId,
    overviewPolyline,
    transportationTime,
    transportationType
  } = results;
  const { poi, index } = findPoiById(itinerary, poiObjectId);
  if (index === null || !poi) {
    return state;
  }

  // update stay time
  const newFormattedPois = updatePoiProperty(itinerary, poiObjectId, {
    route: { _id: routeObjectId },
    transportationType,
    transportationTime,
    overviewPolyline,
    approximateTransportationTimeFlag: false
  });
  // console.log(' new formatted pois = ', newFormattedPois);

  // recalculate time for pois
  calculateTimeForFormattedPoisByDays(
    [poi.daySequence],
    startTime,
    newFormattedPois
  );
  const newState = update(state, {
    data: {
      formattedPois: {
        $set: newFormattedPois
      },
      sortableItemArrayRevision: {
        $set: itinerary.sortableItemArrayRevision
          ? itinerary.sortableItemArrayRevision + 1
          : 1
      }
    }
  });

  // console.log(' newState = ', newState);
  return newState;
};

// sync data : update trip info
const handleUpdateTripInfoSuccess = (state, results) => {
  console.log(' handleUpdateTripInfoSuccess results = ', results);
  const {
    name: tripName,
    start_date_timestamp: startDate,
    end_date_timestamp: endDate,
    revision
  } = results.data;
  const newState = update(state, {
    data: {
      tripName: {
        $set: tripName
      },
      startDate: {
        $set: String(startDate)
      },
      endDate: {
        $set: String(endDate)
      },
      revision: {
        $set: revision
      }
    }
  });
  return newState;
};

// sync data : copy poi
const handleCopyPoiSuccess = (state, results) => {
  const itinerary = state.data;
  const { startTime, dayCount } = itinerary;
  const {
    parsePoiObjectId: poiObjectId,
    copyParsePoiObjectId: copyPoiObjectId,
    copyParsePoiSequenceIndex: copyPoiSequenceIndex,
    copyParseDaySequenceIndex: copyDaySequenceIndex,
    resetTransportationTimeArray,
    revision,
    collaboration
  } = results;
  // copy a poi
  const { poi } = findPoiById(itinerary, poiObjectId);
  const { daySequence } = poi;
  const copyPoi = {
    ...poi,
    poiSequenceIndex: parseFloat(copyPoiSequenceIndex),
    daySequence: copyDaySequenceIndex,
    _id: copyPoiObjectId
  };

  // set routing data to zero for og poi
  const formattedPois = updatePoiProperty(itinerary, poiObjectId, {
    route: {},
    transportationTime: '0',
    overviewPolyline: ''
  });

  // insert copy poi to dayArray
  const { id, dayArray } = formattedPois[parseInt(poi.daySequence, 10)];
  const newDayArray = { id, dayArray: [...dayArray, copyPoi] };

  // sort by poi sequence index
  newDayArray.dayArray = newDayArray.dayArray.sort(sortingByPoiSequence);
  const newFormattedPois = {
    ...formattedPois,
    [parseInt(poi.daySequence, 10)]: newDayArray
  };

  // using resetTransportationTimeArray to reset transportation time of pois
  if (collaboration !== true) {
    resetRouteForFormattedPoisById(
      resetTransportationTimeArray,
      newFormattedPois
    );
  }

  // recalculate time for pois
  calculateTimeForFormattedPoisByDays(
    [daySequence],
    startTime,
    newFormattedPois
  );

  // recalculate sequnce for pois
  recalculateSequenceForFormattedPois(dayCount, newFormattedPois);

  const newState = update(state, {
    data: {
      dispatchRouteRevision: { $set: itinerary.dispatchRouteRevision + 1 },
      formattedPois: {
        $set: newFormattedPois
      },
      revision: {
        $set: revision
      }
    }
  });
  return newState;
};

// sync data : remove pois
const handleRemovePoisSuccess = (state, results) => {
  const itinerary = state.data;
  const { formattedPois, startTime, dayCount } = itinerary;
  const { idArray, resetTransportationTimeArray, revision, collaboration } =
    results;
  let updatedFormattedPois = {};
  const daySequenceArray = [];
  idArray.forEach(objectId => {
    const { poi } = findPoiById(itinerary, objectId);
    if (poi) {
      // get day poi array from newFormattedPois
      // if day poi array is null, get day poi
      // array from original itinerary.formattedPois
      daySequenceArray.push(poi.daySequence);
      const dayObject = updatedFormattedPois[poi.daySequence.toString()];
      let dayPoiArray;
      let dayId;
      if (dayObject) {
        const { id, dayArray } =
          updatedFormattedPois[poi.daySequence.toString()];
        dayPoiArray = dayArray;
        dayId = id;
      }
      if (!dayPoiArray) {
        const { id, dayArray } =
          itinerary.formattedPois[parseInt(poi.daySequence, 10)];
        dayPoiArray = dayArray;
        dayId = id;
      }

      // remove object
      const index = dayPoiArray.map(p => p._id).indexOf(objectId);
      dayPoiArray = [
        ...dayPoiArray.slice(0, index),
        ...dayPoiArray.slice(index + 1)
      ];

      updatedFormattedPois = {
        ...updatedFormattedPois,
        [parseInt(poi.daySequence, 10)]: {
          id: dayId,
          dayArray: [...dayPoiArray]
        }
      };
    }
  });

  // recalculate time for pois
  const newFormattedPois = {
    ...formattedPois,
    ...updatedFormattedPois
  };

  // using resetTransportationTimeArray to reset transportation time of pois
  if (collaboration !== true) {
    resetRouteForFormattedPoisById(
      resetTransportationTimeArray,
      newFormattedPois
    );
  }

  calculateTimeForFormattedPoisByDays(
    daySequenceArray,
    startTime,
    newFormattedPois
  );

  // recalculate sequnce for pois
  recalculateSequenceForFormattedPois(dayCount, newFormattedPois);
  const newState = update(state, {
    data: {
      dispatchRouteRevision: { $set: itinerary.dispatchRouteRevision + 1 },
      formattedPois: { $set: newFormattedPois },
      revision: {
        $set: revision
      }
    }
  });
  return newState;
};

// sync data : post text note
const handlePostTextNoteSuccess = (state, results) => {
  // console.log(' handle post text note success = ', results);
  const itinerary = state.data;
  const {
    parsePoiObjectId: poiObjectId,
    parseTextNoteObjectId,
    shouldSyncWithServer,
    text
  } = results;
  let textNoteObjectId = null;
  if (parseTextNoteObjectId) {
    if (parseTextNoteObjectId.length > 0) {
      textNoteObjectId = parseTextNoteObjectId;
    }
  }
  const { poi, index } = findPoiById(itinerary, poiObjectId);

  if (index === null || !poi) {
    return state;
  }

  const day = poi.daySequence.toString();
  // get post text note command from collaboration server
  if (shouldSyncWithServer) {
    const data = textNoteObjectId
      ? { _id: textNoteObjectId, shouldSyncWithServer }
      : null;
    const newState = update(state, {
      data: {
        formattedPois: {
          [day]: {
            dayArray: {
              [index]: {
                textNote: { $set: data }
              }
            }
          }
        }
      }
    });
    return newState;
  }

  const data = textNoteObjectId
    ? { _id: textNoteObjectId, text, shouldSyncWithServer: false }
    : null;
  const newState = update(state, {
    data: {
      formattedPois: {
        [day]: {
          dayArray: {
            [index]: {
              textNote: { $set: data }
            }
          }
        }
      },
      // for regenerate sotrableItemArray(due to post route will not update revision of
      // itinerary, use sortableItemArrayRevision to update sotrableItemArray)
      // should regenerate sortableItemArray if poi has been updated
      // (for revision has not been updated)
      sortableItemArrayRevision: {
        $set: itinerary.sortableItemArrayRevision
          ? itinerary.sortableItemArrayRevision + 1
          : 1
      }
    }
  });
  // console.log('handle post text note newState =', newState);
  return newState;
};

// sync data : edit alias
const handleEditAliasSuccess = (state, results) => {
  const itinerary = state.data;
  const { aliasName, parsePoiObjectId: poiObjectId } = results;
  const { poi, index } = findPoiById(itinerary, poiObjectId);

  if (index === null || !poi) {
    return state;
  }

  const day = poi.daySequence.toString();
  const newState = update(state, {
    data: {
      formattedPois: {
        [day]: { dayArray: { [index]: { aliasName: { $set: aliasName } } } }
      },
      // for regenerate sotrableItemArray(due to post route will not update revision of
      // itinerary, use sortableItemArrayRevision to update sotrableItemArray)
      // should regenerate sortableItemArray if poi has been updated
      // (for revision has not been updated)
      sortableItemArrayRevision: {
        $set: itinerary.sortableItemArrayRevision
          ? itinerary.sortableItemArrayRevision + 1
          : 1
      }
    }
  });

  return newState;
};

// sync data : customize transoprtation time
const handleCustomizeTransportationTimeSuccess = (state, results) => {
  const itinerary = state.data;
  const { startTime } = itinerary;
  const {
    customizeTransportationTimeFlag,
    customizeTransportationTime,
    parsePoiObjectId: poiObjectId,
    resetTransportationTimeArray,
    collaboration,
    revision
  } = results;
  const updateParameters = { customizeTransportationTimeFlag };
  if (customizeTransportationTimeFlag === '1') {
    updateParameters.customizeTransportationTime = customizeTransportationTime;
  }
  // update customize transportation time
  const newFormattedPois = updatePoiProperty(
    itinerary,
    poiObjectId,
    updateParameters
  );

  // using resetTransportationTimeArray to reset transportation time of pois
  if (collaboration !== true) {
    resetRouteForFormattedPoisById(
      resetTransportationTimeArray,
      newFormattedPois
    );
  }

  const {
    poi: { daySequence }
  } = findPoiById(itinerary, poiObjectId);
  // recalculate time for pois
  calculateTimeForFormattedPoisByDays(
    [daySequence],
    startTime,
    newFormattedPois
  );
  const newState = update(state, {
    data: {
      dispatchRouteRevision: { $set: itinerary.dispatchRouteRevision + 1 },
      formattedPois: {
        $set: newFormattedPois
      },
      revision: {
        $set: revision
      }
    }
  });
  return newState;
};

// sync data : one more day
const handleOneMoreDaySuccess = (state, results) => {
  const { formattedPois } = state.data;
  const { dayCount, revision } = results;
  const key = getKey(0);
  const newDayObject = { [dayCount]: { id: key, dayArray: [] } };
  const newState = update(state, {
    data: {
      dayCount: {
        $set: dayCount
      },
      formattedPois: {
        $set: { ...formattedPois, ...newDayObject }
      },
      revision: {
        $set: revision
      }
    }
  });
  return newState;
};

// sync data : remove days
const handleRemoveDaysSuccess = (state, results) => {
  // console.log(' haneld remove days succss reducer');
  const { formattedPois, startTime } = state.data;
  const { dayCount: newDayCount, dayMatchedObject, revision } = results;

  const updatedFormattedPois = {};
  const updatedStartTime = {};
  // using dayMatchedObject to update formatted pois and start time
  for (const day in dayMatchedObject) {
    if (Object.prototype.hasOwnProperty.call(dayMatchedObject, day)) {
      const newDay = dayMatchedObject[day];
      const { id, dayArray } = formattedPois[day.toString()];
      if (day !== newDay) {
        const updatedDayArray = [];
        dayArray.forEach(poi => {
          const updatedPoi = { ...poi, daySequence: parseInt(newDay, 10) };
          updatedDayArray.push(updatedPoi);
        });
        updatedFormattedPois[newDay.toString()] = {
          id,
          dayArray: updatedDayArray
        };
      } else {
        updatedFormattedPois[newDay.toString()] = { id, dayArray };
      }

      // update start time
      updatedStartTime[newDay.toString()] = startTime[day.toString()];
    }
  }

  const newState = update(state, {
    data: {
      dayCount: {
        $set: newDayCount
      },
      formattedPois: {
        $set: updatedFormattedPois
      },
      startTime: {
        $set: updatedStartTime
      },
      revision: {
        $set: revision
      }
    }
  });
  return newState;
};

// sync data : add poi
const handleAddPoiSuccess = (state, results) => {
  console.log('handleAddPoiSuccess -> results', results);
  const itinerary = state.data;
  if (!itinerary) {
    return state;
  }
  const { formattedPois, dayCount, startTime } = itinerary;
  const { poi, revision, collaboration } = results;
  console.log('handleAddPoiSuccess -> collaboration', collaboration);
  const updatedFormattedPois = { ...formattedPois };
  const { id, dayArray } = updatedFormattedPois[poi.daySequence.toString()];
  const updatedDayArray = [...dayArray, poi];
  updatedFormattedPois[poi.daySequence.toString()] = {
    id,
    dayArray: updatedDayArray
  };
  const poiSequenceIndex = parseFloat(poi.poiSequenceIndex);
  const nexPoiSequenceIndex = state.nexPoiSequenceIndex;

  for (let i = 1; i < Number(dayCount) + 1; i += 1) {
    if (!startTime[i]) {
      startTime[i] = 28800;
    }
  }

  // get new poi sequence
  let newPoiSequenceIndex = 0;
  if (!nexPoiSequenceIndex) {
    // new poi is in the end of the itinerary
    newPoiSequenceIndex = parseFloat(poiSequenceIndex) + 1;
  } else {
    newPoiSequenceIndex =
      (parseFloat(poiSequenceIndex) + parseFloat(nexPoiSequenceIndex)) / 2;
  }

  // recalculate sequnce for pois
  recalculateSequenceForFormattedPois(dayCount, updatedFormattedPois);

  // recalculate time for pois
  calculateTimeForFormattedPoisByDays(
    [poi.daySequence.toString()],
    startTime,
    updatedFormattedPois
  );

  const dispatchRouteRevision =
    collaboration !== true
      ? itinerary.dispatchRouteRevision + 1
      : itinerary.dispatchRouteRevision;

  const newState = update(state, {
    data: {
      dispatchRouteRevision: { $set: dispatchRouteRevision },
      formattedPois: {
        $set: updatedFormattedPois
      },
      revision: {
        $set: revision
      }
    },
    previousPoiSequenceIndex: {
      $set: poiSequenceIndex
    },
    newPoiSequenceIndex: {
      $set: newPoiSequenceIndex
    }
  });
  return newState;
};

// sync data : update permission of trip
// have to access member state. but it is too complicate
// so...just return original state, server will block
// futher requests
const handleUpdatePermissionOfTripSuccess = (state, results) => state;

// sync data : remove travel companions
// have to access member state. but it is too complicate
// so...just return original state, server will block
// futher requests
const handleRemoveTravelCompanionsSuccess = (state, results) => state;

// sync data : reindex poi sequence
const handleReindexPoiSequenceSuccess = (state, results) => {
  // console.log(' handleReindexPoiSequenceSuccess results = ', results);
  const itinerary = state.data;
  const { startTime } = itinerary;
  const {
    parsePoiObjectId: poiObjectId,
    fromDaySequence,
    toDaySequence,
    toPoiSequenceIndex,
    resetTransportationTimeArray,
    revision,
    collaboration
  } = results;

  let updatedFormattedPois;
  const dayArray = [];
  if (fromDaySequence === toDaySequence) {
    // update poi sequence index
    updatedFormattedPois = updatePoiProperty(itinerary, poiObjectId, {
      poiSequenceIndex: parseFloat(toPoiSequenceIndex)
    });

    // sorting
    updatedFormattedPois[fromDaySequence].dayArray =
      updatedFormattedPois[fromDaySequence].dayArray.sort(sortingByPoiSequence);

    // recalculate time for pois
    dayArray.push(fromDaySequence);
  } else {
    updatedFormattedPois = { ...itinerary.formattedPois };
    const { index, poi } = findPoiById(itinerary, poiObjectId);
    // update poi
    const updatedPoi = {
      ...poi,
      daySequence: Number(toDaySequence),
      poiSequenceIndex: parseFloat(toPoiSequenceIndex)
    };

    // remove poi from original day
    const { id: fromDayId, dayArray: fromDayArray } =
      updatedFormattedPois[fromDaySequence];
    const updatedFromDayArray = [
      ...fromDayArray.slice(0, index),
      ...fromDayArray.slice(index + 1)
    ];
    updatedFormattedPois[fromDaySequence] = {
      id: fromDayId,
      dayArray: updatedFromDayArray
    };

    // add poi to new day
    const { id: toDayId, dayArray: toDayArray } =
      updatedFormattedPois[toDaySequence];
    const updatedToDayArray = [...toDayArray, updatedPoi].sort(
      sortingByPoiSequence
    );
    updatedFormattedPois[toDaySequence] = {
      id: toDayId,
      dayArray: updatedToDayArray
    };

    // recalculate time for pois
    dayArray.push(fromDaySequence);
    dayArray.push(toDaySequence);
  }

  // reset transportation time if poi's transportation type is public transit on the given day
  if (collaboration !== true) {
    resetRouteForFormattedPoisById(
      [...resetTransportationTimeArray, poiObjectId],
      updatedFormattedPois
    );
  }

  // recalculate time for pois
  calculateTimeForFormattedPoisByDays(
    dayArray,
    startTime,
    updatedFormattedPois
  );

  // recalculate sequnce for pois
  recalculateSequenceForFormattedPois(itinerary.dayCount, updatedFormattedPois);

  // console.log(' updatedFormattedPois = ', updatedFormattedPois);
  const newState = update(state, {
    data: {
      dispatchRouteRevision: { $set: itinerary.dispatchRouteRevision + 1 },
      formattedPois: {
        $set: updatedFormattedPois
      },
      revision: {
        $set: revision
      }
    }
  });
  return newState;
};

const handleReindexDaySequenceSuccess = (state, results) => {
  let sequence = 0;
  const itinerary = state.data;
  const { startTime, revision, dayMatchedObject, indexMatchedObject } = results;
  // 深拷貝
  const newFormattedPois = JSON.parse(JSON.stringify(itinerary.formattedPois));

  Object.keys(dayMatchedObject).forEach(item => {
    const newDayindex = dayMatchedObject[item];
    newFormattedPois[newDayindex] = itinerary.formattedPois[item];

    if (newFormattedPois[newDayindex].dayArray.length) {
      newFormattedPois[newDayindex].dayArray = newFormattedPois[
        newDayindex
      ].dayArray.map(item2 => ({
        ...item2,
        daySequence: Number(newDayindex),
        poiSequenceIndex: indexMatchedObject[item2._id]
      }));
    }
  });

  // 要處理更新後每筆景點的 sequence 必須重新 loop 一遍..
  // 沒辦法在上面的 Object.keys + forEach + map 更新 sequence，因為上面的 loop 過程天數還是舊的
  // 要重算 sequence 只能在上方 return 新算出的 newFormattedPois 重新 loop 才會準
  Object.keys(newFormattedPois)
    .sort((a, b) => (Number(a) > Number(b) ? 1 : -1)) // 按天數由小排至大
    .forEach(item3 => {
      if (newFormattedPois[item3].dayArray.length) {
        newFormattedPois[item3].dayArray = newFormattedPois[item3].dayArray.map(
          item4 => {
            sequence += 1;
            return {
              ...item4,
              sequence
            };
          }
        );
      }
    });

  const newItinerary = {
    ...itinerary,
    startTime,
    revision,
    formattedPois: newFormattedPois
  };
  const newState = update(state, {
    data: {
      $set: newItinerary
    }
  });
  return newState;
};

// sync data : rearrange poi sequence
const handleRearrangePoiSequenceSuccess = (state, results) => {
  const itinerary = state.data;
  const updatedItinerary = { ...itinerary };
  const { pois } = results;
  updatedItinerary.pois = pois;
  updatedItinerary.formattedPois = generateFormattedPois(updatedItinerary);
  delete updatedItinerary.pois;

  const newState = update(state, {
    data: {
      $set: updatedItinerary
    }
  });
  return newState;
};

// util methods
const getKey = number => {
  const randomNumber = `_${Math.random().toString(36).substr(3, 15)}`;
  const key = randomNumber + Math.floor(Date.now()) + number;
  return key.toString();
};

const findPoiById = (itinerary, poiObjectId) => {
  let poi = null;
  let index = null;
  for (let i = 1; i <= parseInt(itinerary.dayCount, 10); i++) {
    const dayArray = itinerary.formattedPois[i.toString()].dayArray;
    // console.log(' dayArray = ', dayArray);
    for (let j = 0; j < dayArray.length; j++) {
      const p = dayArray[j];
      if (p._id === poiObjectId) {
        index = j;
        poi = p;
        break;
      }
    }
  }
  // console.log(' findPoiById index = ', index);
  // console.log(' findPoiById poi = ', poi);
  return { index, poi };
};

const findDayPoiArrayById = (itinerary, poiObjectId) => {
  let poi = null;
  for (let i = 1; i <= parseInt(itinerary.dayCount, 10); i++) {
    const dayArray = itinerary.formattedPois[i.toString()].dayArray;
    for (let j = 0; j < dayArray.length; j++) {
      const p = dayArray[j];
      if (p._id === poiObjectId) {
        poi = p;
        break;
      }
    }
  }
  return itinerary.formattedPois[poi.daySequence.toString()];
};

// recalculate poi.sequence
const recalculateSequenceForFormattedPois = (dayCount, formattedPois) => {
  const updatedFormattedPois = formattedPois;
  let sequence = 1;
  for (let i = 1; i <= dayCount; i++) {
    const { id, dayArray: dayPoiArray } = updatedFormattedPois[i];
    const newDayPoiArray = dayPoiArray.map(poi => {
      const p = { ...poi };
      p.sequence = sequence;
      sequence++;
      return p;
    });
    updatedFormattedPois[i] = { id, dayArray: newDayPoiArray };
  }
};

// reset route data
const resetRouteForFormattedPoisByDay = (days, formattedPois) => {
  const updatedFormattedPois = formattedPois;
  // object format
  // {daySequence: "3", minPoiSequence: -1}
  days.forEach(object => {
    const { daySequence, minPoiSequence } = object;
    const { id, dayArray: dayPoiArray } = updatedFormattedPois[daySequence];
    const newDayPoiArray = dayPoiArray.map(poi => {
      const p = poi;
      if (
        parseFloat(p.poiSequenceIndex) >= parseFloat(minPoiSequence) &&
        (p.transportationType === '1' || p.transportationType === '3')
      ) {
        p.transportationTime = '-1';
        p.overviewPolyline = '';
        p.route = {};
        // console.log(' reset route name = ', p.name);
        // console.log(' reset route poi sequence index = ', p.poiSequenceIndex);
      }
      return p;
    });
    updatedFormattedPois[daySequence] = { id, dayArray: newDayPoiArray };
  });

  return updatedFormattedPois;
};

// reset route data
const resetRouteForFormattedPoisById = (ids, formattedPois) => {
  const updatedFormattedPois = formattedPois;
  // object format
  // {daySequence: "3", minPoiSequence: -1}
  for (const key of Object.keys(formattedPois)) {
    const { id, dayArray: dayPoiArray } = formattedPois[key];
    const newDayPoiArray = dayPoiArray.map(poi => {
      const p = poi;
      if (ids.indexOf(p._id) > -1) {
        p.transportationTime = '-1';
        p.overviewPolyline = '';
        p.route = {};
        // console.log(' reset route name = ', p.name);
        // console.log(' reset route poi sequence index = ', p.poiSequenceIndex);
      }
      return p;
    });
    updatedFormattedPois[key] = { id, dayArray: newDayPoiArray };
  }

  return updatedFormattedPois;
};

// update poi's property and return new formatted pois
const updatePoiProperty = (itinerary, poiObjectId, property) => {
  const { formattedPois } = itinerary;
  const {
    poi: { daySequence }
  } = findPoiById(itinerary, poiObjectId);
  const { id, dayArray } = findDayPoiArrayById(itinerary, poiObjectId);
  const newDayPoiArray = dayArray.map(poi => {
    if (poi._id === poiObjectId) {
      return { ...poi, ...property };
    }
    return poi;
  });
  const newFormattedPois = {
    ...formattedPois,
    ...{ [daySequence]: { id, dayArray: newDayPoiArray } }
  };
  return newFormattedPois;
};

const sortingByPoiSequence = (a, b) =>
  a.poiSequenceIndex > b.poiSequenceIndex ? 1 : -1;

const handleChangeTransportationAirplaneType = (state, payload) => {
  const { _id, daySequence } = payload;

  const newDayArray = state.data.formattedPois[daySequence].dayArray.map(
    item => {
      if (item._id === _id) {
        return { ...item, transportationType: '8' };
      }
      return item;
    }
  );
  const newState = {
    ...state,
    data: {
      ...state.data,
      dispatchRouteRevision: state.data.dispatchRouteRevision + 1,
      sortableItemArrayRevision: state.data.sortableItemArrayRevision
        ? state.data.sortableItemArrayRevision + 1
        : 1,
      formattedPois: {
        ...state.data.formattedPois,
        [daySequence]: {
          ...state.data.formattedPois[daySequence],
          dayArray: newDayArray,
          approximateTransportationTimeFlag: true
        }
      }
    }
  };
  return newState;
};

/** addAirplaneApproximateTransportationTimeFlag
 * 按目前架構 approximateTransporataionTimeFlag 是前端新增到 Redux 參數
 * 會決定是否在 socket 局部更新 approximateTransporataionTimeFlag 後
 * PoiRoute update 後向後端 fetch 完整資料(路徑或是飛機資訊)更新
 * ex:手機輸入第一筆航班資料後 > socket 通知 web > React update 有 approximateTransporataionTimeFlag 就去 fetch 資料
 * 但全部交通工具的 fetch action 都是 fetchPoiRouteSuccess 耦合在一起較難辨別哪個交通工具
 * 且並不是每個交通工具 fetchPoiRouteSuccess 後 approximateTransporataionTimeFlag 還要為 true
 * 只有飛機是(可以多次掃瞄 QRcode 後到手機多次輸入航班 socket 通知 web > PoiRoute React update 有 approximateTransporataionTimeFlag 就去 fetch 資料回 web 更新）
 * 若此處不更新 approximateTransporataionTimeFlag 會導致飛機輸入完第一筆後 再次掃描新增而網頁不更新 因為少了 approximateTransporataionTimeFlag 在 React update 後 fetch 資料 的步驟
 */
const addAirplaneApproximateTransportationTimeFlag = (state, payload) => {
  const { daySequence, _id } = payload.fromPoi;
  /**
   * 要判斷是 dayArray Array 內哪一筆序號資料才能更新
   * store 內 dayArray 內 object 雖然有 sequence 之類的編號 但 sequence 是全天數加總 poi 的序號而不是該天數 dayArray 的序號
   * 第一天的 dayArray 還能用 sequence 去抓到、第二天第三天...後就無法以 sequence 去抓到了 故只能 findIndex 自己找
   */
  const index = state.data.formattedPois[daySequence].dayArray.findIndex(
    item => item._id === _id
  );

  const newState = update(state, {
    data: {
      formattedPois: {
        [daySequence]: {
          dayArray: {
            [index]: { approximateTransportationTimeFlag: { $set: true } }
          }
        }
      }
    }
  });
  return newState;
};

const handleCommentsOfTrips = (state, payload) => {
  const { newCommentData, count } = payload;
  const { data } = state.commemts;
  data.unshift(newCommentData);
  const newState = update(state, {
    commemts: {
      data: { $set: data }
    },
    data: {
      commentCount: { $set: count }
    }
  });
  return newState;
};

const handlReplysOfComments = (state, payload) => {
  const { newReplyData, count, commentIndex } = payload;
  const { data } = state.commemts;
  data[commentIndex].replies.unshift(newReplyData);
  const newState = update(state, {
    commemts: {
      data: { $set: data }
    },
    data: {
      commentCount: { $set: count }
    }
  });
  return newState;
};

const handlDeleteCommentsOfTrips = (state, payload) => {
  const { count, commentIndex } = payload;
  const { data } = state.commemts;
  data.splice(commentIndex, 1);
  const newState = update(state, {
    commemts: {
      data: { $set: data }
    },
    data: {
      commentCount: { $set: count }
    }
  });
  return newState;
};

const handlDeleteReplysOfComments = (state, payload) => {
  const { count, replyIndex, commentIndex } = payload;
  const { data } = state.commemts;
  data[commentIndex].replies.splice(replyIndex, 1);
  const newState = update(state, {
    commemts: {
      data: { $set: data }
    },
    data: {
      commentCount: { $set: count }
    }
  });
  return newState;
};

const handelConcatNextReply = (state, payload) => {
  const { newReplyData, replies_next, commentIndex } = payload;
  const { replies } = state.commemts.data[commentIndex];
  const newReplies = [...replies, ...newReplyData];
  const newState = update(state, {
    commemts: {
      data: {
        [commentIndex]: {
          replies_next: { $set: replies_next },
          replies: { $set: newReplies }
        }
      }
    }
  });
  return newState;
};
